/* HOME v2: the scroll reveals of the home page (sections/home-*.liquid). YourBrandFuel, 2026-10-06.
   A part marked data-hv2-reveal fades in and rises into its place the first time it scrolls into view; marked
   data-hv2-reveal="stagger", its direct children come in one after another. The movement itself is written in
   assets/home-v2.css (the block headed "THE SCROLL REVEALS"); this file only says when.

   Every home section that carries a marked part loads this file, with defer, as its last line. It runs once,
   however many sections ask for it: the first run leaves data-hv2-js on the html element and the others stop
   there.

   What a visitor must never get is a hole in the page, so:
   - Nothing is hidden by the stylesheet alone. It hides a marked part only under the class hv2-anim on the html
     element, and only this file sets that class.
   - Before it sets it, every marked part that is on the screen, or above it, is given is-in (shown, with no
     movement). Only parts further down the page start hidden, where nobody can see them go.
   - From then on a part gets is-in when about a sixth of it has come into view (at least 56px of it, or all of
     it when it is smaller than that; a part taller than the screen when it fills about a third of the
     screen). A part the page jumps past, by a link to a band further down, is shown at once.
   - It does nothing for a visitor who asked for less motion, and nothing in a browser without
     IntersectionObserver. On any error it takes hv2-anim away again and the page is whole.
   - In the theme editor the parts of a section that is added or changed are given is-in at once, so nothing
     in it waits for a scroll. */
(function () {
  var root = document.documentElement;
  if (root.hasAttribute('data-hv2-js')) return;
  root.setAttribute('data-hv2-js', '');

  try {
    if (!('IntersectionObserver' in window) || !root.classList) return;
    var calm = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    if (calm && calm.matches) return;

    var marked = document.querySelectorAll('[data-hv2-reveal]');
    var screenHeight = window.innerHeight || root.clientHeight || 0;
    var waiting = [];
    var i;

    /* 1. what is on the screen already, or above it, is simply there. Every place is read first and only then
       is anything written, so the page is measured once and not once for each part. */
    var here = [];
    for (i = 0; i < marked.length; i++) here.push(marked[i].getBoundingClientRect().top < screenHeight);
    for (i = 0; i < marked.length; i++) {
      if (here[i]) {
        marked[i].classList.add('is-in');
      } else {
        waiting.push(marked[i]);
      }
    }

    /* 2. only now may the stylesheet hide the parts that are still waiting further down */
    root.classList.add('hv2-anim');

    /* 3. show each waiting part as it comes into view. The watched area reaches far above the screen, so a part
       that a jump down the page has skipped counts as seen and is not left hidden above the visitor. */
    var watcher = new IntersectionObserver(function (entries) {
      try {
        var tall = (window.innerHeight || screenHeight) * 0.3;
        for (var n = 0; n < entries.length; n++) {
          var entry = entries[n];
          if (!entry.isIntersecting) continue;
          var seen = entry.intersectionRect.height;
          var enough = entry.intersectionRatio >= 0.16 || seen >= tall;
          var plain = seen >= 56 || entry.intersectionRatio >= 0.99;
          if (enough && plain) {
            entry.target.classList.add('is-in');
            watcher.unobserve(entry.target);
          }
        }
      } catch (error) {
        root.classList.remove('hv2-anim');
      }
    }, { rootMargin: '20000px 0px 0px 0px', threshold: [0, 0.02, 0.05, 0.1, 0.16, 0.25, 0.35, 0.5, 0.75, 1] });

    for (i = 0; i < waiting.length; i++) watcher.observe(waiting[i]);

    /* the theme editor: the parts of a section that has just been added or changed do not wait for a scroll */
    document.addEventListener('shopify:section:load', function (event) {
      try {
        var fresh = event.target.querySelectorAll('[data-hv2-reveal]');
        for (var n = 0; n < fresh.length; n++) fresh[n].classList.add('is-in');
      } catch (error) {
        root.classList.remove('hv2-anim');
      }
    });
  } catch (error) {
    try { root.classList.remove('hv2-anim'); } catch (ignore) {}
  }
})();
